import { getCurrentLanguage } from '@eureka/language-tool';

/**
 * 获取美元价格展示
 * @param price - 价格
 * @returns 美元价格
 */
export const getDollarPriceDisplay = (price: number) => {
    return `$${price}`;
};

export function removeAuthToken() {
    localStorage.removeItem('patsnap-authorizations');
}

export function formatShortDate(dateStr: number, options?: Intl.DateTimeFormatOptions): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    // 根据当前语言格式化日期
    // jp: 'ja-JP',
    switch (getCurrentLanguage()) {
    case 'cn':
        return date.toLocaleDateString('zh-CN', { month: 'short', day: 'numeric', ...options });
    case 'tw':
        return date.toLocaleDateString('zh-TW', { month: 'short', day: 'numeric', ...options });
    case 'jp':
        return date.toLocaleDateString('ja-JP', { month: 'short', day: 'numeric', ...options });
    default:
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', ...options });
    }
}
